import React from 'react';
import { Hero } from './components/Hero';
import { Problema } from './components/Problema';
import { Transformacion } from './components/Transformacion';
import { Modulos } from './components/Modulos';
import { ParaQuien } from './components/ParaQuien';
import { Instructora } from './components/Instructora';
import { Testimonios } from './components/Testimonios';
import { Incluye } from './components/Incluye';
import { Faq } from './components/Faq';
import { CtaFinal } from './components/CtaFinal';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white" data-id="element-0" data-mp="31aqf2ee30qq7">
      <main data-id="element-1" data-mp="31bs09botatln">
        <Hero data-id="element-2" data-mp="31c9uy3vtszrg" />
        <Problema data-id="element-3" data-mp="31c1ksjr388jy" />
        <Transformacion data-id="element-4" data-mp="31cjk5p91r2w3" />
        <Modulos data-id="element-5" data-mp="2wjgptewg3peu" />
        <ParaQuien data-id="element-6" data-mp="2wiyvintcfl9k" />
        <Instructora data-id="element-7" data-mp="2wifbn1k4umsw" />
        <Testimonios data-id="element-8" data-mp="2wi5nzkmk8rqd" />
        <Incluye data-id="element-9" data-mp="28u5ysp4wd9dw" />
        <Faq data-id="element-10" data-mp="28tme50nv46w6" />
        <CtaFinal data-id="element-11" data-mp="28t4lee0esat0" />
      </main>
      <Footer data-id="element-12" data-mp="28sb9kymlev40" />
    </div>;
}